import { IconElement } from "./schemas/icon";
import { Point } from "./schemas/canvas-element";
import { createElementId, getUnixTimestampUTC, textEnabledDefaults } from "shared/util/utils";
import { ElementTextProperties } from "./canvas-element";

export type IconInitOptions = {
  href: string;
  text?: string;
  width?: number;
  height?: number;
  libraryPath?: string;
} & ElementTextProperties;

export function placeIcon(point: Point, init: IconInitOptions, defaultSize: number) {
  const {
    width = defaultSize,
    height = defaultSize,
    href,
    text,
    font = textEnabledDefaults.font,
    fontSize = textEnabledDefaults.fontSize,
    align = textEnabledDefaults.align,
    textColor = textEnabledDefaults.textColor,
    fontProps = textEnabledDefaults.fontProps,
    libraryPath,
  } = init;

  const center = {
    x: point.x - width / 2,
    y: point.y - height / 2,
  };

  return {
    id: createElementId(),
    icon: {
      type: "icon",
      x: center.x,
      y: center.y,
      href,
      text,
      font,
      fontSize,
      align,
      textColor,
      fontProps,
      attachedConnectors: {},
      scaleX: 1,
      scaleY: 1,
      zIndexLastChangeTime: getUnixTimestampUTC(),
      width,
      height,
      libraryPath,
    } as IconElement,
  };
}
